import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material'
import { useActiveRole, useRoles } from 'hooks'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCurrentUser,
  selectCurrentUserRoles,
  logOut,
  switchRole,
} from 'features'
import ChangeActiveUserPasswordDialog from 'components/dialog/ChangeActiveUserPasswordDialog'

function AppBarUserMenu(_props) {
  const dispatch = useDispatch()

  const currentUser = useSelector(selectCurrentUser)
  const currentUserRoles = useSelector(selectCurrentUserRoles)

  const [activeRoles] = useActiveRole()

  const [roles] = useRoles()

  const rolSwitch = () => {
    if (
      currentUserRoles.includes('Oraculo') &&
      process.env.REACT_APP_ENABLE_ROLE_SWAP === 'true'
    ) {
      return roles.map((role) => {
        return {
          label: 'Actuar como rol ' + role.rolename,
          action: () => dispatch(switchRole(role)),
        }
      })
    }
    return []
  }
  const userMenuOptions = [...rolSwitch()]

  const [anchorElUser, setAnchorElUser] = React.useState(null)

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  return (
    <>
      <div className="flex flex-row gap-4">
        <Tooltip title="Ajustes de usuario">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar
              className="w-[3rem] h-[3rem]"
            >
              {currentUser?.firstname[0]}{currentUser?.lastname[0]}
            </Avatar>
          </IconButton>
        </Tooltip>
        <div>
          <Typography variant="h5" component="div">
            {currentUser?.firstname} {currentUser?.lastname}
          </Typography>
          <Typography variant="caption" component="div" className="uppercase">
            {activeRoles || [].join(', ')}
          </Typography>
        </div>
      </div>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        onClick={handleCloseUserMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {userMenuOptions.map((option) => (
          <MenuItem key={option.label} onClick={option.action}>
            <Typography textAlign="left" component="div" className="w-full">
              {option.label}
            </Typography>
          </MenuItem>
        ))}
        <ChangeActiveUserPasswordDialog togglerComponent={MenuItem}>
          <Typography textAlign="left" component="div" className="w-full">
            Cambiar contraseña
          </Typography>
        </ChangeActiveUserPasswordDialog>
        <MenuItem onClick={() => dispatch(logOut())}>
          <Typography textAlign="left" component="div" className="w-full">
            Cerrar sesión
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}

export default AppBarUserMenu
